import { useDataSubmit } from 'Simple/Data.js'

/** @type {import('Simple/type.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let submit = useDataSubmit({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    let referrals = value.filter(v => {
      if (!v?.id) return false

      switch (v.template.type) {
        case 'DropDown':
          return v.selected_index !== null
        case 'FreeText':
          return v.text_value !== ''
        case 'Search':
          return typeof v.person !== 'undefined'
        default:
          return false
      }
    })

    if (referrals.length > 0) {
      let { person_referrals, template_referrals } = formatReferrals(referrals)
      submit({
        type: 'updateReferrals',
        person_referrals,
        template_referrals,
      })
    }
  }
}

function formatReferrals(referrals) {
  let template_referrals = []
  let person_referrals = []
  referrals.forEach(referral => {
    switch (referral.template.type) {
      case 'DropDown':
        template_referrals.push({
          referral_template_id: referral.template.id,
          text_value:
            referral.referral_list_values.find(
              v => v.id === referral.selected_index
            ).text ?? '',
        })
        break
      case 'FreeText':
        template_referrals.push({
          referral_template_id: referral.template.id,
          text_value: referral.text_value,
        })
        break
      case 'Search':
        person_referrals.push({
          person_type: referral.template.text,
          person_id: referral.person.id,
        })
        break
      default:
        break
    }
  })

  return { template_referrals, person_referrals }
}
